export enum LoyaltyRoutePathNames {
  LOYALTY = 'loyalty',

  CAMPAIGNS = 'campaigns',
  VOUCHERS = 'vouchers',
  REWARDS = 'rewards',
  SEGMENTS = 'segments',
  BUNDLES = 'bundles',
  REPORTING = 'reporting',
  CUSTOMERS = 'customers',

  LIST = '',
  CREATE = 'create',
  DETAIL = ':id',
  EDIT = ':id/edit',
  CARD_DETAIL = ':id/cards/:customerId',
}
